const Donate = () => {
  return (
    <div className="donate">
      <div className="container">
        <a className="anchor" id="Donate" name="Donate" />

        <div className="row center">
            <h5>In Loving Memory Of Carrie F. David Norton</h5>
            <div className="hr"></div>
        </div>
        <div className="row">
          <div className="col s12 m6 l6">
            <img width="300"  src={process.env.PUBLIC_URL + '/images/Carrie-David-Norton.jpg'} />
          </div>
          <div className="col s12 m6 l6 center">
            <p>April 12, 1977 - September 27, 2025</p>
            <p>&nbsp;</p>
            <a target="_blank" href="https://www.paypal.com/qrcodes/managed/44a56651-dd06-41c0-8477-29ac0d3ff7d0?utm_source=consapp_download"><img width="200" src={process.env.PUBLIC_URL + '/images/Carrie-donate.png'} /></a>
            <br/>
            (Click, tap, or scan to make a donation)
          </div>
        </div>

        <div className="row left-align">
          <p>Carrie F. Norton, 48</p>
          <p>She is the wife of Jim Norton</p>
          <p>She is the mother of Tessa Norton</p>
          <p>
            She is the daughter of Timothy David and Cindy (Rogers) David
            Livingston
          </p>
          <p>She attended Eastbrook High School</p>
          <p>She was a member of First Community Church, Matthews</p>
          <p>
            Carrie F. Norton, 48, of Upland, passed away peacefully at her home
            surrounded by her loving family after a courageous battle with
            cancer.
          </p>
          <p>
            Her greatest joy in life was her daughter, Tessa, who was the light
            of her world. She cherished spending time with her family and
            extended loved ones.
          </p>
          <p>
            Known for her incredible work ethic, Carrie found purpose and joy in
            working, gardening, cleaning, thrifting and always keeping busy.
          </p>
          <p>
            She had a love for volleyball, excelling as a spiker during junior
            high and senior high school.
          </p>
          <p>
            Carrie played volleyball for both Heritage Hall Academy, Muncie, and
            Faith Christian Academy, Berne, and later playing at Taylor
            University, Upland.
          </p>
          <p>She also enjoyed her time as a cheerleader.</p>
          <p>
            Carrie's education included home schooling, Chapel Heights Academy,
            Marion, Faith Christian Academy, Berne, Eastbrook High School as a
            freshman and Heritage Hall Christian School, Muncie, where she
            graduated.
          </p>
          <p>
            She went on to earn her bachelor's degree in business administration
            from Taylor University, Upland.
          </p>
          <p>
            Carrie's faith was central to her life. She received Christ and was
            baptized at Union Chapel Baptist Church, Marion.
          </p>
          <p>She was a member of First Community Church, Matthews. </p>
          <p>
            Carrie and her husband were owners of Walnut Creek Outdoors, Gas
            City, where they not only shared a business partnership, but also a
            deep bond as soulmates, celebrating life together in everything they
            did.
          </p>
          <p>
            She was born on April 12, 1977, in Marion to Timothy David and Cindy
            (Rogers) David Livingston.
          </p>
          <p>
            On July 29, 2000, Carrie married the love of her life, Jim, and
            together they built a beautiful life over 25 years of marriage.
          </p>
          <p>
            She is survived by her husband, Jim; daughter, Tessa; mother, Cindy
            (Gary) Livingston; father, Timothy David; siblings, Becky David and
            Jeff David; father- and mother-in-law, Bill and Janie Norton;
            sister-in-law, Jenny (Matthew) Norton Schamber; nieces and nephews,
            Zoey, Zaavan, Jarrett, Brady, Brooklyn, Kennedy and Cadence; several
            aunts and uncles to whom she cared for very much.
          </p>
          <p>
            Carrie was preceded in death by her grandparents, Gerald "Duke" and
            Janet David, Earl and Mary Rogers, Vern and Martelle Norton and
            James and Lucy Doris Moore, and great-grandparents, Paul and Edna
            Rogers, Jack and Freda David and Russell and Margaret Dunn.
          </p>
          <p>
            A Life Celebration for Carrie will be at 6 p.m. on Wednesday, Oct.
            1, 2025, at Armes-Hunt Life Celebration Funeral Home and Cremation
            Services, Jones-Smith Chapel, 259 N. Main St., Upland, with Pastor
            Doug Rogers, Pastor Devin Miller and Pastor Robert Morrell
            officiating. Interment will follow at Matthews Cemetery in Matthews,
            Indiana. Family and friends may gather for visitation from 3:00-6:00
            p.m. prior to the service.
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
  );
};

export default Donate;
